<template>
  <div class="user-profile">
    <c-avatar
      size="lg"
      :image="user.avatar" />
    <h3 class="name">{{ user.name || user.document || '' }}</h3>
  </div>
</template>

<script>
import { USER } from '@store/types'
import { mapGetters } from 'vuex'

export default {
  computed: mapGetters({
    user: USER
  })
}
</script>

<style lang="scss">
@import '~@style/reference';

.user-profile {
  padding-top: 46px;
  padding-bottom: 18px;
  position: relative;

  &::before {
    content: '';
    position: absolute;
    top: -20px;
    left: 0;
    height: 130px;
    width: 100%;
    background-image: url('~../../assets/img/pattern-oferta.svg');
    background-repeat: repeat-y;
  }

  & > .name {
    color: $title-color;
    text-transform: uppercase;
    font-size: 14px;
    line-height: 19px;
    margin-top: 14px;
    margin-bottom: 3px;
  }
  & > .withdraw {
    color: $text-color;
    font-size: 12px;
    line-height: 13px;
    margin-bottom: 12px;

    & > span { font-weight: 700; }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/User/UserProfile.vue